export enum EInvoicingPreferences {
  OutgoingInvoicesAndExpenses = 'outgoing_invoices_and_expenses',
  OutgoingInvoicesOnly = 'outgoing_invoices_only',
  NoPreference = 'no_preference',
}

export interface PreferencesStepValues {
  eInvoicingPreference: EInvoicingPreferences;
}
